import { defineStore } from 'pinia'

export const userMainStore = defineStore('main', {
	state: () => ({
		options: {
			isopen: false,
			isavailable: false,
			hidefooter: false
		}
	}),
	actions: {

	}
	// getters
	// actions
})